/** INVUX1 (UX baseline findings 06 and 13): rare setup and maintenance actions sit behind one named "Setup" disclosure
 * beside the page's primary action. Nothing is removed: each action is one tap deeper. A native details element, so a
 * keyboard opens it with Enter or Space; Escape or a press elsewhere closes it and returns focus to its summary. */
export function createSetupDisclosure(
  testid: string,
  actions: readonly HTMLButtonElement[],
): HTMLDetailsElement {
  const details = document.createElement("details");
  details.className = "setup-disclosure";
  details.dataset["testid"] = testid;
  const summary = document.createElement("summary");
  summary.textContent = "Setup";
  details.append(summary);
  const menu = document.createElement("div");
  menu.className = "setup-disclosure-menu";
  menu.append(...actions);
  details.append(menu);
  const close = (event: Event): void => {
    if (!details.open) return;
    if (event instanceof KeyboardEvent) {
      if (event.key !== "Escape") return;
      details.open = false;
      summary.focus();
      return;
    }
    if (event.target instanceof Node && details.contains(event.target)) return;
    details.open = false;
  };
  details.addEventListener("toggle", () => {
    if (details.open) {
      document.addEventListener("pointerdown", close, true);
      document.addEventListener("keydown", close, true);
    } else {
      document.removeEventListener("pointerdown", close, true);
      document.removeEventListener("keydown", close, true);
    }
  });
  // Choosing an action closes the menu so the page underneath is not left half open.
  menu.addEventListener("click", () => {
    details.open = false;
  });
  return details;
}
